/* eslint-disable simple-import-sort/imports */
import JILI from "assets/images/game/table-card/bg-jili.png";
import KM from "assets/images/game/Slot/slot-km.png";
import { SubGameType } from "types/game";

export const listGameTableCard: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "JILI",
    type: "BG",
    featured: "NO",
    new_arrive: "NO",
    picture: JILI
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "KM",
    type: "BG",
    featured: "NO",
    new_arrive: "NO",
    picture: KM
  }
];
